import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import pdfIcon from "../../../../assets/images/icons/resourcePdfIcon.svg";
import pdfIconDark from "../../../../assets/images/icons/resourcePdfIconDark.svg";
import videoIcon from "../../../../assets/images/icons/resourceVideoIcon.svg";
import videoIconDark from "../../../../assets/images/icons/resourceVideoIconDark.svg";
import downloadIcon from "../../../../assets/images/icons/resourceDownloadIcon.svg";
import downloadIconDark from "../../../../assets/images/icons/resourceDownloadIconDark.svg";
import viewIcon from "../../../../assets/images/icons/resourceViewIcon.svg";
import viewIconDark from "../../../../assets/images/icons/resourceViewIconDark.svg";
import ReseorcePPTIcon from "../../../../assets/images/icons/resoursepptIcon.svg";
import ReseorcePPTIconDark from "../../../../assets/images/icons/resoursepptIconDark.svg";
import bookmarken from "../../../../assets/uploads/Bookmark Eng_final.pdf";
import bookmarkhi from "../../../../assets/uploads/Bookmark Hindi_final.pdf";
import brochureen from "../../../../assets/uploads/Brochure_Eng_final.pdf";
import brochurehi from "../../../../assets/uploads/Brochure_Hindi_final.pdf";
import EvaluatorUserManualEn from "../../../../assets/uploads/Evaluator User Guide Web.pdf";
import EvaluatorUserManualHindiWeb from "../../../../assets/uploads/Evaluator User Guide Hindi Web.pdf";
import EvaluatorUserManualEngMobile from "../../../../assets/uploads/Evaluator User Guide Mobile.pdf";
import DNOUserManualEn from "../../../../assets/uploads/DNO User Guide Web.pdf";
import DNOUserManualHindi from "../../../../assets/uploads/DNO User Guide Hindi Web.pdf";
import EvaluatorUserManualHindi from "../../../../assets/uploads/Evaluator User Guide Hindi Mobile.pdf";
// import guidelineshi from "../../../../assets/uploads/hindi-swachh-bharat.pdf";
// import guidelinesen from "../../../../assets/uploads/english-swachh-bharat.pdf";
// import usermanualWeben from "../../../../assets/uploads/english-user-manual-web.pdf";
// import usermanualMobileen from "../../../../assets/uploads/english-user-manual-mobile.pdf";
// import usermanualHindiWeb from "../../../../assets/uploads/hindi-user-manual-web.pdf";
// import usermanualHindiMobile from "../../../../assets/uploads/hindi-user-manual-mobile.pdf";
import VideoModal from "./VideoModal";

const Resources = () => {
  const { t } = useTranslation("home");
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedVideoType, setSelectedVideoType] = useState<
    "TechnicalVideo" | "UserManualVideo"
  >("TechnicalVideo");
  const [downloadingFiles, setDownloadingFiles] = useState<Set<string>>(
    new Set()
  );

  const guidelineshi = `https://www.dsel-education.gov.in/static/uploads/2026/09/03eaa016bac6f34e364c9efaa183624c.pdf`;
  const guidelinesen = `https://www.dsel-education.gov.in/static/uploads/2026/08/11d9facc71295d768cfd751ba69a7ae9.pdf`;
  const usermanualHindiWeb = `https://www.dsel-education.gov.in/static/uploads/2026/09/f4bd46282ffc33b0fcc4e59d7353fe13.pdf`;
  const usermanualWeben = `https://www.dsel-education.gov.in/static/uploads/2026/09/e99ad8ba35679d4e85f73ecdbd3a9ed7.pdf`;
  const usermanualHindiMobile = `https://www.dsel-education.gov.in/static/uploads/2026/09/424c178c1c154692c8bc84006d13bd24.pdf`;
  const usermanualMobileen = `https://www.dsel-education.gov.in/static/uploads/2026/09/1fce052153657e32af64ec17d32f7651.pdf`;

  // Sample resource data
  const resources = [
    {
      name: t("resources.resourceNames.guidelines"),
      size: "20.0 MB",
      hindiSize: "7.3 MB",
      englishSize: "20.0 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "Guidelines",
    },
     {
      name: t("resources.resourceNames.brochure"),
      size: "2.2 MB",
      hindiSize: "0.3 MB",
      englishSize: "2.2 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "brochure",
    },
     {
      name: t("resources.resourceNames.bookmark"),
      size: "0.2 MB",
      hindiSize: "0.2 MB",
      englishSize: "0.2 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "bookmark",
    },
    // {
    //   name: "Guidelines (Mobile)",
    //   size: "5.98 MB",
    //   type: "pdf",
    //   hasHindi: true,
    //   hasEnglish: true,
    // },
    {
      name: t("resources.resourceNames.userManualWeb"),
      size: "22.0 MB",
      hindiSize: "18.1 MB",
      englishSize: "22.0 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "UserManualWeb",
    },
    {
      name: t("resources.resourceNames.userManualMobile"),
      size: "22.8 MB",
      hindiSize: "20.8 MB",
      englishSize: "22.8 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "UserManualMobile",
    },
    {
      name: t("resources.resourceNames.userManualEvaluatorWeb"),
      size: "10.4 MB",
      hindiSize: "9.9 MB",
      englishSize: "10.4 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "UserManualEvaluatorWeb",
    },
    {
      name: t("resources.resourceNames.userManualEvaluatorMobile"),
      size: "11.8 MB",
      hindiSize: "11.8 MB",
      englishSize: "11.8 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "UserManualEvaluatorMobile",
    },
    {
      name: t("resources.resourceNames.userManualDNOWeb"),
      size: "13.0 MB",
      hindiSize: "13.0 MB",
      englishSize: "7.7 MB",
      type: "pdf",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "UserManualDNOWeb",
    },
    {
      name: t("resources.resourceNames.technicalVideo"),
      size: "--",
      type: "video",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "TechnicalVideo",
    },
    {
      name: t("resources.resourceNames.technicalVideoMobile"),
      size: "--",
      type: "video",
      hasHindi: true,
      hasEnglish: true,
      uniqueName: "UserManualVideo",
    },
    // {
    //   name: t("resources.resourceNames.programOverview"),
    //   size: "6 MB",
    //   englishSize: "6 MB",
    //   hindiSize: "2 MB",
    //   type: "ppt",
    //   hasHindi: true,
    //   hasEnglish: true,
    //   uniqueName: "ProgramOverview",
    // },
    // {
    //   name: t("resources.resourceNames.actionPlanning"),
    //   size: "1 MB",
    //   englishSize: "1 MB",
    //   hindiSize: "1 MB",
    //   type: "ppt",
    //   hasHindi: true,
    //   hasEnglish: true,
    //   uniqueName: "ActionPlanning",
    // },
    // {
    //   name: t("resources.resourceNames.participationGuide"),
    //   size: "33 MB",
    //   englishSize: "33 MB",
    //   hindiSize: "4 MB",
    //   type: "ppt",
    //   hasHindi: true,
    //   hasEnglish: true,
    //   uniqueName: "ParticipationGuide",
    // },
  ];

  const handleDownloadGuidelines = async (
    resourceName: string,
    language: string
  ) => {
    const downloadKey = `${resourceName}-${language}`;

    // Add to downloading files set
    setDownloadingFiles((prev) => new Set(prev).add(downloadKey));

    // Determine URL based on resource type
    let url;
    let isPPT = false;

    if (resourceName === "Guidelines") {
      url =
        language === "hi"
          ? guidelineshi
          : guidelinesen;
    } else if (resourceName === "bookmark") {
      url =
        language === "hi"
          ? bookmarkhi
          : bookmarken;
    }else if (resourceName === "brochure") {
      url =
        language === "hi"
          ? brochurehi
          : brochureen;
    }else if (resourceName === "UserManualWeb") {
      url =
        language === "hi"
          ? usermanualHindiWeb
          : usermanualWeben;
    } else if (resourceName === "UserManualMobile") {
      url =
        language === "hi"
          ? usermanualHindiMobile
          : usermanualMobileen;
    } else if (resourceName === "ProgramOverview") {
      url =
        language === "hi"
          ? `https://www.education.gov.in/sites/upload_files/mhrd/files/SHVR/hindi/Programme-Overview_Hindi.pdf`
          : `https://www.education.gov.in/sites/upload_files/mhrd/files/SHVR/english/Programme-Overview.pdf`;
      isPPT = true;
    } else if (resourceName === "ActionPlanning") {
      url =
        language === "hi"
          ? `https://www.education.gov.in/sites/upload_files/mhrd/files/SHVR/hindi/Planning-Rollout_Hindi.pdf`
          : `https://www.education.gov.in/sites/upload_files/mhrd/files/SHVR/english/Planning-Rollout.pdf`;
      isPPT = true;
    } else if (resourceName === "ParticipationGuide") {
      url =
        language === "hi"
          ? `https://www.education.gov.in/sites/upload_files/mhrd/files/SHVR/hindi/Participation-Guide_Hindi.pdf`
          : `https://www.education.gov.in/sites/upload_files/mhrd/files/SHVR/english/Participation-Guide_English.pdf`;
      isPPT = true;
    } else if (resourceName === "UserManualEvaluatorWeb") {
      url = 
        language === "hi" 
          ? EvaluatorUserManualHindiWeb 
          : EvaluatorUserManualEn;
    } else if (resourceName === "UserManualEvaluatorMobile") {
      url =
        language === "hi"
          ? EvaluatorUserManualHindi
          : EvaluatorUserManualEngMobile;
    } else if (resourceName === "UserManualDNOWeb") {
      url = 
        language === "hi"
          ? DNOUserManualHindi
          : DNOUserManualEn;
    } else {
      // Default fallback
      url =
        language === "hi"
          ? `${
              import.meta.env.VITE_API_BASE_URL
            }/static/pdf/guidelines/SHVR_Guidelines_Hindi.pdf`
          : `${
              import.meta.env.VITE_API_BASE_URL
            }/static/pdf/guidelines/SHVR_Guidelines_English.pdf`;
    }

    try {
      if (isPPT) {
        // Download PPT file directly
        // const link = document.createElement("a");
        // link.href = url;
        // link.download = url.split("/").pop() || "download.pptx";
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        window.open(url, "_blank", "noopener,noreferrer");
      } else {
        // Open PDF in new tab (existing functionality)
        window.open(url, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Error handling file:", error);
    } finally {
      // Remove from downloading files set
      setDownloadingFiles((prev) => {
        const newSet = new Set(prev);
        newSet.delete(downloadKey);
        return newSet;
      });
    }
  };

  const handleView = (resourceName: string, language: string) => {
    setSelectedVideoType(
      resourceName === "UserManualVideo" ? "UserManualVideo" : "TechnicalVideo"
    );
    setSelectedLanguage(language);
    setVideoModalOpen(true);
  };

  const resourceTypeIcon = (type: string) => {
    if (type === "video") {
      return isDarkMode ? videoIconDark : videoIcon;
    }
    if (type === "ppt") {
      return isDarkMode ? ReseorcePPTIconDark : ReseorcePPTIcon;
    }
    return isDarkMode ? pdfIconDark : pdfIcon;
  };

  const renderAction = (
    resource: (typeof resources)[number],
    language: "hi" | "en"
  ) => {
    const isHindi = language === "hi";
    const isAvailable = isHindi ? resource.hasHindi : resource.hasEnglish;
    const languageLabel = isHindi ? "Hindi" : "English";
    const downloadKey = `${resource.uniqueName}-${language}`;
    const isVideo = resource.type === "video";

    if (!isAvailable) {
      return (
        <Box
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xs: "calc(50% - 4px)", xl: "auto" },
            minWidth: { xs: 0, lg: 166 },
            minHeight: 38,
            color: isDarkMode ? "#a7a7a7" : "#667085",
            fontSize: "18px",
            fontWeight: 500,
          }}
        >
          —
        </Box>
      );
    }

    return (
      <Button
        variant="outlined"
        startIcon={
          <img
            src={
              isVideo
                ? isDarkMode
                  ? viewIconDark
                  : viewIcon
                : isDarkMode
                ? downloadIconDark
                : downloadIcon
            }
            alt=""
            style={{ width: 18, height: 18 }}
          />
        }
        onClick={() =>
          isVideo
            ? handleView(resource.uniqueName, languageLabel)
            : handleDownloadGuidelines(resource.uniqueName, language)
        }
        sx={{
          minWidth: { xs: 0, lg: 166 },
          minHeight: 38,
          px: 2,
          py: 0.5,
          color: isDarkMode ? "#ededed" : "#171717",
          backgroundColor: isDarkMode ? "#353535" : "#fff",
          borderColor: isDarkMode ? "#626262" : "#d9d9d9",
          borderRadius: "999px",
          textTransform: "none",
          fontSize: `calc(14px * var(--dynamic-font-size, 1))`,
          whiteSpace: "nowrap",
          boxShadow: "0 1px 3px rgba(0,0,0,.05)",
          "&:hover": {
            borderColor: isDarkMode ? "#a0a0a0" : "#1A5F20",
            backgroundColor: isDarkMode ? "#404040" : "#f8fff8",
          },
        }}
      >
        {downloadingFiles.has(downloadKey) ? (
          t("resources.buttons.opening")
        ) : (
          <>
            <Box
              component="span"
              sx={{ display: { xs: "none", lg: "inline" } }}
            >
              {`${
                isVideo
                  ? t("resources.buttons.view")
                  : t("resources.buttons.download")
              } (${languageLabel})`}
            </Box>
            <Box
              component="span"
              sx={{ display: { xs: "inline", lg: "none" } }}
            >
              {languageLabel}
            </Box>
          </>
        )}
      </Button>
    );
  };

  return (
    <Box
      sx={{
        background: "transparent",
        pt: { xs: 3, md: "45px" },
        pb: { xs: 6, md: 10 },
        minHeight: "calc(100vh - 210px)",
      }}
    >
      <Container
        maxWidth={false}
        sx={{ width: { xs: "100%", sm: "94%", md: "88%" } }}
      >
        <Typography
          component="h1"
          sx={{
            mb: { xs: 3, md: 4.5 },
            pl: { md: 1 },
            fontWeight: 700,
            color: isDarkMode ? theme.palette.text.primary : "#0F202B",
            fontSize: {
              xs: `calc(34px * var(--dynamic-font-size, 1))`,
              md: `calc(48px * var(--dynamic-font-size, 1))`,
            },
            lineHeight: 1.15,
          }}
        >
          {t("resources.title")}
        </Typography>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            overflowX: "auto",
            // minHeight: { md: 610 },
            border: `1px solid ${isDarkMode ? "#5f6666" : "#5de4d2"}`,
            borderRadius: { xs: "24px", md: "44px" },
            padding: { xs: "16px", sm: "24px", lg: 0 },
            background: isDarkMode
              ? "linear-gradient(180deg, #292d2f 0%, #25322c 100%)"
              : "linear-gradient(180deg, rgba(255,255,255,.96) 0%, rgba(235,255,235,.78) 100%)",
          }}
        >
          <Table
            className="resources-table"
            aria-label={t("resources.title")}
            sx={{
              minWidth: 850,
              tableLayout: "fixed",
              "& .MuiTableCell-root": {
                borderColor: isDarkMode
                  ? "rgba(255,255,255,.12)"
                  : "rgba(163,180,184,.34)",
              },
            }}
          >
            <TableHead>
              <TableRow sx={{ height: 86 }}>
                <TableCell
                  sx={{
                    width: "38%",
                    pl: { xs: 3, md: 10 },
                    fontWeight: 700,
                    fontSize: `calc(18px * var(--dynamic-font-size, 1))`,
                    color: isDarkMode ? "#f0f0f0" : "#364153",
                  }}
                >
                  {t("resources.tableHeaders.resourceName")}
                </TableCell>
                <TableCell
                  sx={{
                    width: "19%",
                    fontWeight: 700,
                    fontSize: `calc(18px * var(--dynamic-font-size, 1))`,
                    color: isDarkMode ? "#f0f0f0" : "#364153",
                  }}
                >
                  File Size
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: "43%",
                    fontWeight: 700,
                    fontSize: `calc(18px * var(--dynamic-font-size, 1))`,
                    color: isDarkMode ? "#f0f0f0" : "#364153",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {resources.map((resource) => (
                <TableRow key={resource.uniqueName} sx={{ height: 80 }}>
                  <TableCell sx={{ pl: { xs: 0, lg: 6 } }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: { xs: "flex-start", lg: "center" },
                        gap: { xs: 1.5, lg: 2.5 },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: { xs: 42, lg: "auto" },
                          height: { xs: 42, lg: "auto" },
                          borderRadius: { xs: "10px", lg: 0 },
                          backgroundColor: {
                            xs: isDarkMode
                              ? "rgba(255,255,255,0.06)"
                              : "#FFF7ED",
                            lg: "transparent",
                          },
                          flexShrink: 0,
                        }}
                      >
                        <Box
                          component="img"
                          src={resourceTypeIcon(resource.type)}
                          alt=""
                          sx={{
                            width:
                              resource.type === "pdf"
                                ? { xs: 24, lg: 44 }
                                : { xs: 24, lg: 44 },
                            height:
                              resource.type === "pdf"
                                ? { xs: 26, lg: 48 }
                                : { xs: 26, lg: 48 },
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          minWidth: 0,
                          flex: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            display: { xs: "block", lg: "none" },
                            color: isDarkMode ? "#4ade80" : "#008236",
                            fontWeight: 700,
                            fontSize: "11px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            lineHeight: 1.2,
                            mb: 0.5,
                          }}
                        >
                          {resource.type === "video"
                            ? "VIDEO"
                            : resource.type === "ppt"
                            ? "PRESENTATION"
                            : "DOCUMENT"}
                        </Typography>
                        <Typography
                          sx={{
                            color: isDarkMode ? "#f1f1f1" : "#1E2939",
                            fontWeight: 700,
                            fontSize: {
                              xs: "15px",
                              lg: `calc(16px * var(--dynamic-font-size, 1))`,
                            },
                            lineHeight: 1.35,
                          }}
                        >
                          {resource.name}
                        </Typography>
                        <Typography
                          sx={{
                            display: { xs: "block", lg: "none" },
                            color: isDarkMode ? "#94a3b8" : "#64748b",
                            fontSize: "12px",
                            mt: 0.5,
                            fontWeight: 500,
                          }}
                        >
                          {resource.size} · {resource.type.toUpperCase()}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell
                    sx={{
                      color: isDarkMode ? "#c7c7c7" : "#52606f",
                      fontSize: `calc(16px * var(--dynamic-font-size, 1))`,
                    }}
                  >
                    {resource.size}
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                        width: "100%",
                        "& .MuiButton-root": {
                          width: { xs: "calc(50% - 4px)", xl: "auto" },
                          minWidth: { xs: 0, xl: 166 },
                        },
                      }}
                    >
                      {renderAction(resource, "hi")}
                      {renderAction(resource, "en")}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <VideoModal
        open={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
        language={selectedLanguage}
        videoType={selectedVideoType}
      />
    </Box>
  );

  if (false) {
  return (
    <Box
      sx={{
        backgroundColor: isDarkMode
          ? theme.palette.background.paper
          : "#EFF9FF",
        py: { xs: 4, md: 4 },
        minHeight: "calc(100vh - 210px)",
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid size={12}>
            <Box
              sx={{
                backgroundColor: isDarkMode
                  ? theme.palette.background.paper
                  : "#f0faff",
                py: { xs: 0, md: 2 },
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: "8px",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 600,
                  color: isDarkMode ? theme.palette.text.primary : "#0F202B",
                  fontSize: {
                    xs: `calc(20px * var(--dynamic-font-size, 1)) !important`,
                    sm: `calc(24px * var(--dynamic-font-size, 1)) !important`,
                    md: `calc(34px * var(--dynamic-font-size, 1)) !important`,
                  },
                  marginRight: 2,
                }}
              >
                {t("resources.title")}
              </Typography>
            </Box>
          </Grid>
          <Grid
            size={12}
            sx={{
              boxShadow: "0px 1.24px 2.47px -1.24px #0000001A",
            }}
          >
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                borderRadius: "12px",
                padding: { xs: "15px", md: "25px" },
              }}
            >
              <Table>
                <TableHead
                  sx={{
                    "& .MuiTableCell-root": {
                      fontWeight: 700,
                      color: isDarkMode
                        ? theme.palette.text.primary
                        : "#364153",
                      fontSize: {
                        xs: `calc(12px * var(--dynamic-font-size, 1)) !important`,
                        md: `calc(16px * var(--dynamic-font-size, 1)) !important`,
                      },
                      borderBottom: isDarkMode
                        ? "2.5px solid rgba(255, 255, 255, 0.1)"
                        : "2.5px solid rgba(228, 228, 228, 0.5)",
                    },
                  }}
                >
                  <TableRow>
                    <TableCell sx={{ width: "40%" }}>
                      {t("resources.tableHeaders.resourceName")}
                    </TableCell>
                    <TableCell align="center" sx={{ width: "30%" }}>
                      {t("resources.tableHeaders.hindi")}
                    </TableCell>
                    <TableCell align="center" sx={{ width: "30%" }}>
                      {t("resources.tableHeaders.english")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {resources.map((resource, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        borderBottom: isDarkMode
                          ? "2.5px solid rgba(255, 255, 255, 0.1)"
                          : "2.5px solid rgba(228, 228, 228, 0.5)",
                      }}
                    >
                      {/* Resource Name */}
                      <TableCell sx={{ width: "40%" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          {resource.type === "pdf" ? (
                            <img
                              src={isDarkMode ? pdfIconDark : pdfIcon}
                              alt="PDF"
                              style={{
                                width: "36px",
                                height: "36px",
                              }}
                            />
                          ) : resource.type === "ppt" ? (
                            <img
                              src={
                                isDarkMode
                                  ? ReseorcePPTIconDark
                                  : ReseorcePPTIcon
                              }
                              alt="PPT"
                              style={{
                                width: "36px",
                                height: "36px",
                              }}
                            />
                          ) : (
                            <img
                              src={isDarkMode ? videoIconDark : videoIcon}
                              alt="Video"
                              style={{
                                width: "36px",
                                height: "36px",
                              }}
                            />
                          )}
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: isDarkMode
                                ? theme.palette.text.primary
                                : "#364153",
                              fontSize: {
                                xs: `calc(12px * var(--dynamic-font-size, 1)) !important`,
                                md: `calc(16px * var(--dynamic-font-size, 1)) !important`,
                              },
                            }}
                          >
                            {resource.name}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Hindi Column */}
                      <TableCell align="center" sx={{ width: "30%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {!resource.hasHindi ? (
                            <Typography
                              sx={{
                                color: isDarkMode
                                  ? theme.palette.text.secondary
                                  : "#6B7280",
                                fontSize: { xs: "12px", md: "14px" },
                                fontWeight: 500,
                              }}
                            >
                              --
                            </Typography>
                          ) : resource.type === "pdf" ? (
                            <Button
                              variant="outlined"
                              startIcon={
                                downloadingFiles.has(
                                  `${resource.uniqueName}-hi`
                                ) ? (
                                  <Box
                                    component="span"
                                    sx={{
                                      width: "16px",
                                      height: "16px",
                                      border: "2px solid #000000",
                                      borderTop: "2px solid transparent",
                                      borderRadius: "50%",
                                      animation: "spin 1s linear infinite",
                                      "@keyframes spin": {
                                        "0%": { transform: "rotate(0deg)" },
                                        "100%": {
                                          transform: "rotate(360deg)",
                                        },
                                      },
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={
                                      isDarkMode
                                        ? downloadIconDark
                                        : downloadIcon
                                    }
                                    alt="Download"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                    }}
                                  />
                                )
                              }
                              onClick={() =>
                                handleDownloadGuidelines(
                                  resource.uniqueName,
                                  "hi"
                                )
                              }
                              disabled={downloadingFiles.has(
                                `${resource.uniqueName}-hi`
                              )}
                              sx={{
                                color: isDarkMode
                                  ? theme.palette.text.primary
                                  : "#000000",
                                borderColor: "#E5E7EB",
                                textTransform: "none",
                                fontSize: { xs: "10px", md: "12px" },
                                minWidth: "auto",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "20px",
                                "&:hover": {
                                  borderColor: isDarkMode
                                    ? theme.palette.text.primary
                                    : "#000000",
                                  backgroundColor: "transparent",
                                },
                                "&:disabled": {
                                  opacity: 0.6,
                                },
                              }}
                            >
                              {downloadingFiles.has(`${resource.uniqueName}-hi`)
                                ? t("resources.buttons.opening")
                                : `${t("resources.buttons.download")} (${
                                    resource.hindiSize || resource.size
                                  })`}
                            </Button>
                          ) : resource.type === "ppt" ? (
                            <Button
                              variant="outlined"
                              startIcon={
                                downloadingFiles.has(
                                  `${resource.uniqueName}-hi`
                                ) ? (
                                  <Box
                                    component="span"
                                    sx={{
                                      width: "16px",
                                      height: "16px",
                                      border: "2px solid #000000",
                                      borderTop: "2px solid transparent",
                                      borderRadius: "50%",
                                      animation: "spin 1s linear infinite",
                                      "@keyframes spin": {
                                        "0%": { transform: "rotate(0deg)" },
                                        "100%": {
                                          transform: "rotate(360deg)",
                                        },
                                      },
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={
                                      isDarkMode
                                        ? downloadIconDark
                                        : downloadIcon
                                    }
                                    alt="Download"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                    }}
                                  />
                                )
                              }
                              onClick={() =>
                                handleDownloadGuidelines(
                                  resource.uniqueName,
                                  "hi"
                                )
                              }
                              disabled={downloadingFiles.has(
                                `${resource.uniqueName}-hi`
                              )}
                              sx={{
                                color: isDarkMode
                                  ? theme.palette.text.primary
                                  : "#000000",
                                borderColor: "#E5E7EB",
                                textTransform: "none",
                                fontSize: { xs: "10px", md: "12px" },
                                minWidth: "auto",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "20px",
                                "&:hover": {
                                  borderColor: isDarkMode
                                    ? theme.palette.text.primary
                                    : "#000000",
                                  backgroundColor: "transparent",
                                },
                                "&:disabled": {
                                  opacity: 0.6,
                                },
                              }}
                            >
                              {downloadingFiles.has(`${resource.uniqueName}-hi`)
                                ? t("resources.buttons.opening")
                                : `${t("resources.buttons.download")} (${
                                    resource.hindiSize || resource.size
                                  })`}
                            </Button>
                          ) : (
                            <Button
                              variant="outlined"
                              startIcon={
                                <img
                                  src={isDarkMode ? viewIconDark : viewIcon}
                                  alt="View"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                              }
                              onClick={() =>
                                handleView(resource.uniqueName, "Hindi")
                              }
                              sx={{
                                color: isDarkMode
                                  ? theme.palette.text.primary
                                  : "#000000",
                                borderColor: "#E5E7EB",
                                textTransform: "none",
                                fontSize: { xs: "10px", md: "12px" },
                                minWidth: "auto",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "20px",
                                "&:hover": {
                                  borderColor: isDarkMode
                                    ? theme.palette.text.primary
                                    : "#000000",
                                  backgroundColor: "transparent",
                                },
                              }}
                            >
                              {t("resources.buttons.view")}
                            </Button>
                          )}
                        </Box>
                      </TableCell>

                      {/* English Column */}
                      <TableCell align="center" sx={{ width: "30%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {resource.type === "pdf" ? (
                            <Button
                              variant="outlined"
                              startIcon={
                                downloadingFiles.has(
                                  `${resource.uniqueName}-en`
                                ) ? (
                                  <Box
                                    component="span"
                                    sx={{
                                      width: "16px",
                                      height: "16px",
                                      border: "2px solid #000000",
                                      borderTop: "2px solid transparent",
                                      borderRadius: "50%",
                                      animation: "spin 1s linear infinite",
                                      "@keyframes spin": {
                                        "0%": { transform: "rotate(0deg)" },
                                        "100%": {
                                          transform: "rotate(360deg)",
                                        },
                                      },
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={
                                      isDarkMode
                                        ? downloadIconDark
                                        : downloadIcon
                                    }
                                    alt="Download"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                    }}
                                  />
                                )
                              }
                              onClick={() =>
                                handleDownloadGuidelines(
                                  resource.uniqueName,
                                  "en"
                                )
                              }
                              disabled={downloadingFiles.has(
                                `${resource.uniqueName}-en`
                              )}
                              sx={{
                                color: isDarkMode
                                  ? theme.palette.text.primary
                                  : "#000000",
                                borderColor: "#E5E7EB",
                                textTransform: "none",
                                fontSize: { xs: "10px", md: "12px" },
                                minWidth: "auto",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "20px",
                                "&:hover": {
                                  borderColor: isDarkMode
                                    ? theme.palette.text.primary
                                    : "#000000",
                                  backgroundColor: "transparent",
                                },
                                "&:disabled": {
                                  opacity: 0.6,
                                },
                              }}
                            >
                              {downloadingFiles.has(`${resource.uniqueName}-en`)
                                ? t("resources.buttons.opening")
                                : `${t("resources.buttons.download")} (${
                                    resource.englishSize || resource.size
                                  })`}
                            </Button>
                          ) : resource.type === "ppt" ? (
                            <Button
                              variant="outlined"
                              startIcon={
                                downloadingFiles.has(
                                  `${resource.uniqueName}-en`
                                ) ? (
                                  <Box
                                    component="span"
                                    sx={{
                                      width: "16px",
                                      height: "16px",
                                      border: "2px solid #000000",
                                      borderTop: "2px solid transparent",
                                      borderRadius: "50%",
                                      animation: "spin 1s linear infinite",
                                      "@keyframes spin": {
                                        "0%": { transform: "rotate(0deg)" },
                                        "100%": {
                                          transform: "rotate(360deg)",
                                        },
                                      },
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={
                                      isDarkMode
                                        ? downloadIconDark
                                        : downloadIcon
                                    }
                                    alt="Download"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                    }}
                                  />
                                )
                              }
                              onClick={() =>
                                handleDownloadGuidelines(
                                  resource.uniqueName,
                                  "en"
                                )
                              }
                              disabled={downloadingFiles.has(
                                `${resource.uniqueName}-en`
                              )}
                              sx={{
                                color: isDarkMode
                                  ? theme.palette.text.primary
                                  : "#000000",
                                borderColor: "#E5E7EB",
                                textTransform: "none",
                                fontSize: { xs: "10px", md: "12px" },
                                minWidth: "auto",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "20px",
                                "&:hover": {
                                  borderColor: isDarkMode
                                    ? theme.palette.text.primary
                                    : "#000000",
                                  backgroundColor: "transparent",
                                },
                                "&:disabled": {
                                  opacity: 0.6,
                                },
                              }}
                            >
                              {downloadingFiles.has(`${resource.uniqueName}-en`)
                                ? t("resources.buttons.opening")
                                : `${t("resources.buttons.download")} (${
                                    resource.englishSize || resource.size
                                  })`}
                            </Button>
                          ) : (
                            <Button
                              variant="outlined"
                              startIcon={
                                <img
                                  src={isDarkMode ? viewIconDark : viewIcon}
                                  alt="View"
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                              }
                              onClick={() =>
                                handleView(resource.uniqueName, "English")
                              }
                              sx={{
                                color: isDarkMode
                                  ? theme.palette.text.primary
                                  : "#000000",
                                borderColor: "#E5E7EB",
                                textTransform: "none",
                                fontSize: { xs: "10px", md: "12px" },
                                minWidth: "auto",
                                px: 1.5,
                                py: 0.5,
                                borderRadius: "20px",
                                "&:hover": {
                                  borderColor: isDarkMode
                                    ? theme.palette.text.primary
                                    : "#000000",
                                  backgroundColor: "transparent",
                                },
                              }}
                            >
                              {t("resources.buttons.view")}
                            </Button>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>

      <VideoModal
        open={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
        language={selectedLanguage}
        videoType={selectedVideoType}
      />
    </Box>
  );
  }
};

export default Resources;
